angular.module('questionManagement', [
  'common',
  'ngResource',
  'ui.bootstrap',
  'ngCookies',
  'ui.router'
]);

require('./routes');
